import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingComponent } from './loading.component';

@NgModule({
    imports: [CommonModule, TranslatePipe, TranslateDirective, MatProgressSpinnerModule],
    declarations: [LoadingComponent],
    exports: [LoadingComponent]
})
export class LoadingModule {}
